export default class SectionNav {
	constructor() {

		document.addEventListener( 'DOMContentLoaded', this.ready() );
	}

	ready() {
		const node = document.querySelector('.section-nav');
		this.node = node;

		if (!node) {
			return;
		}

		this.opts = {
			prev: node.querySelector('.section-nav__link--prev'),
			next: node.querySelector('.section-nav__link--next'),
			link: node.querySelector('.section-nav__link'),
			// container: node.querySelector('.section-nav__inner'),
			container: node.querySelector('.section-nav__body'),
			navs: node.querySelectorAll('.section-nav__nav'),
			primaryNav: document.querySelector('.masthead'),
			listPadding: 100,
			classes: {
				navActive: 'section-nav__nav--active',
				pinned: 'section-nav--pinned',
				activeLink: 'section-nav__link--active',
				animationActive: 'animated-block--active'
			}
		};

		if(!this.opts.container) {
			return;
		}

		this.previousY = 0;
		this.list = this.opts.container.querySelector('ul');

		if (!this.list) {
			return;
		}

		this.navStartPosition = 0;
		this.touchPreviousX = 0;
		this.passed = false;
		this.buffer = 5;

		this.opts.prev.addEventListener('mousedown', (event) => this.reverse(event));
		this.opts.prev.addEventListener('touchstart', (event) => this.reverse(event));

		this.opts.next.addEventListener('mousedown', (event) => this.forward(event));
		this.opts.next.addEventListener('touchstart', (event) => this.forward(event));

		this.opts.prev.addEventListener('mouseup', () => this.stop());
		this.opts.prev.addEventListener('touchend', () => this.stop());
		this.opts.prev.addEventListener('touchcancel', () => this.stop());

		this.opts.next.addEventListener('mouseup', () => this.stop());
		this.opts.next.addEventListener('touchend', () => this.stop());
		this.opts.next.addEventListener('touchcancel', () => this.stop());

		// this.opts.container.addEventListener('touchmove', (event) => this.drag(event));

		// hide navigation arrows if not needed.
		this.maybeHideNav();
		addEventListener('resize', () => this.maybeHideNav());

		this.menuLinks = this.list.querySelectorAll('button');
		this.menuLinks.forEach((link) => {
			link.addEventListener('click', (event) => {
				const panel = document.getElementById(event.target.dataset.href);
				panel.scrollIntoView({
					behavior: 'smooth',
					block: 'center'
				});
			});
		})
		const ids = [...this.menuLinks].map((button) => button.dataset.href);
		const sectionIds = [...ids].filter((id) => document.getElementById(id));
		const sections = sectionIds.map((id) => document.getElementById(id));
		this.observers = {
			sectionNavInView: new IntersectionObserver(
				(entries) => this.sectionNavInView(entries),
				{
					threshold: [0.1, 0.13, 0.14, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 0.99, 1],
				}
			),
			sectionInView:  new IntersectionObserver(
				(entries) => this.sectionInView(entries),
				{
					threshold: 1,
				}
			),
		};

		sections.forEach((section) => {
			this.observers.sectionInView.observe(section);
		});

		this.observers.sectionNavInView.observe(this.node);

		// trigger reveal animation.
		setTimeout( () => {
			this.node.classList.add(this.opts.classes.animationActive);
		}, 1750);
	}

	sectionInView(entries) {

		entries.forEach((entry) => {
			const matchingLink = this.list.querySelector(`[data-href="${entry.target.id}"]`);
			if (entry.isIntersecting) {
				if (!matchingLink) {
					return;
				}

				this.menuLinks.forEach((link) => {
					link.classList.remove(this.opts.classes.activeLink);
				});
				matchingLink.classList.add(this.opts.classes.activeLink);
			} else {
				matchingLink.classList.remove(this.opts.classes.activeLink);
			}
		});
	}

	show() {
		this.opts.primaryNav.style.setProperty('transform', 'translateY(-100%)');
		this.node.classList.add(this.opts.classes.pinned);
	}

	hide() {
		this.node.classList.remove(this.opts.classes.pinned);
		this.opts.primaryNav.style.setProperty('transform', 'translateY(0)');
	}

	sectionNavInView(entries) {

		entries.forEach((entry) => {

			if ( entry.isIntersecting ) {
				this.interval = setInterval(() => {

					const distanceFromTopOfViewport = this.node.getBoundingClientRect().y;

					if ( window.scrollY < this.previousY) {
						this.hide();

					} else if (distanceFromTopOfViewport < this.buffer &&  window.scrollY > this.previousY ) {
						if (!this.navStartPosition) {
							this.navStartPosition = window.scrollY;
						}
						this.show();
					}

					if ( this.navStartPosition ) {
						if (window.scrollY - this.navStartPosition <= this.buffer) {
							this.hide();
						}
					}

					this.previousY = window.scrollY;
				}, 333);

			} else {
				window.onscroll = false;
				clearInterval(this.interval);
			}
		});
	}

	maybeHideNav() {

		if (this.list.offsetWidth - this.opts.listPadding > this.opts.container.offsetWidth) {
			[ ...this.opts.navs].forEach((nav) => nav.classList.add(this.opts.classes.navActive));
		} else {
			[ ...this.opts.navs].forEach((nav) => nav.classList.remove(this.opts.classes.navActive));
		}
	}

	reverse() {
		this.interval = setInterval( () => {
			this.opts.container.scrollLeft -= 10;
			if (this.opts.container.scrollLeft <= 5) {
				this.stop();
			}
		}, 10);
		this.maybeDisable();
	}

	forward() {
		this.interval = setInterval( () => {
			this.opts.container.scrollLeft += 3;
		}, 5);
		this.opts.prev.disabled = false;
		this.maybeDisable();
	}

	stop() {
		clearInterval( this.interval );
		this.maybeDisable();
	}

	maybeDisable() {
		const scrollLeft = this.opts.container.scrollLeft;

		// reached beginning of list
		if ( scrollLeft <= 30 ) {
			this.opts.prev.disabled = true;
			this.opts.next.disabled = false;
		} else {
			this.opts.prev.disabled = false;
		}
	}
}


